import React from 'react';

import { Box, Spacer, Typography, Button } from '@bcp-nextgen-dx-component-factory/design-system';
import { ComponentInfo, ComposableTextLink, ContactYouSoon } from '@components';
import { rem } from '@helpers';

import { SubscriptionStatus, useConclusionHelper } from './conclusion.helper';

export const ConclusionPlaceholder: React.FC = () => {
	const { resources, status, animationPendingRef, animationSuccessRef, onHandleLeave } = useConclusionHelper();

	return (
		<ComponentInfo name="ConclusionPlaceholder" type="placeholder">
			<Box
				styles={{
					flexDirection: 'column',
					alignItems: 'center',
					gap: rem(90),
					height: '100%',
				}}
			>
				<Box
					styles={{
						flexDirection: 'column',
						alignItems: 'center',
						height: '100%',
					}}
				>
					<Box>
						{status === SubscriptionStatus.pending ? (
							<div className="lottie" ref={animationPendingRef} />
						) : (
							<div className="lottie" ref={animationSuccessRef} />
						)}
					</Box>
					<Spacer vertical={rem(40)} />
					{status === SubscriptionStatus.pending ? (
						<Box
							styles={{
								flexDirection: 'column',
								alignItems: 'center',
								textAlign: 'center',
								width: rem(840),
							}}
						>
							<Typography appearance="subtitle-200-02">{resources.pendingTitleOne}</Typography>
							<Spacer vertical={rem(16)} />
							<ComposableTextLink
								typography={{
									text: resources.pendingTitleTwo,
									appearance: 'body-100-02',
									colorToken: 'interaction-03-90',
								}}
								link={{
									text: resources.pendingTitleTwoLink,
									url: resources.pendingTitleTwoUrl,
									appearance: 'body-100-02',
									colorToken: 'interaction-01-100',
								}}
							/>
						</Box>
					) : (
						<Box styles={{ flexDirection: 'column', alignItems: 'center', width: rem(840) }}>
							<Typography appearance="headline-300-02">{resources.successTitleOne}</Typography>
							<Spacer vertical={rem(16)} />
							<Typography appearance="subtitle-200-02">{resources.successTitleTwo}</Typography>
						</Box>
					)}
					<Spacer vertical={rem(40)} />
					<ContactYouSoon />
				</Box>
				<Box styles={{ justifyContent: 'center' }}>
					<Button variant="light" appearance="outline" size="medium" onPress={onHandleLeave}>
						{resources.backToHomepage}
					</Button>
				</Box>
			</Box>
		</ComponentInfo>
	);
};
